import { Injectable } from '@angular/core';
import { Store, State } from '@ngrx/store';
import { Observable } from 'rxjs';

import { Loadable } from '../common/loadable';
import { AppState } from '../app.state';
import {
    ChangeMissingSideMembersSortExpressionAction,
    ChangeMissingSideMembersFilterExpressionAction,
    ChangeMissingSideMembersPageAction,
    LoadMissingSideMembersPageAction,
    ChangeMissingSideMembersTotalCountAction
} from './action';

import { Paging } from '..';
import { MissingSideMembersState } from './state';
import { MissingSideMembersApiService } from 'src/api/services/missing-side-members-api.service';
import { toNumber } from 'lodash';
import { MissingSideMembers } from './state-models/missing-side-members';

@Injectable()
export class MissingSideMembersStateService {
    private resources = require('../../state/common/resources.json');
    constructor(
        private missingSideMembersApiService: MissingSideMembersApiService,
        private appStore: Store<AppState>,
        private appState: State<AppState>) { }

    @Loadable()
    async loadMissingSideMembers(
        allocationScaniaUnitId: number[],
        from: string,
        to: string,
        paging: Paging,
        sortExpression: string,
        filterExpression: string,
        forceRefetch: boolean = false) {
        const payload = {
            from: new Date(from).toISOString(),
            to: new Date(to).toISOString(),
            allocationScaniaUnit: allocationScaniaUnitId,
            paging: paging,
            order: sortExpression,
            filter: filterExpression
        };
        const missingSideMembers = await this.missingSideMembersApiService.getMissingSideMembersList(payload, forceRefetch); 

        this.appStore.dispatch(new LoadMissingSideMembersPageAction(missingSideMembers.list));
        this.appStore.dispatch(new ChangeMissingSideMembersTotalCountAction(missingSideMembers.totalCount));
    }

    async refetchList(allocationScaniaUnitId: number[], from: string, to: string): Promise<void> { 
        const state = <MissingSideMembersState>this.appState.getValue().missingSideMembers;
        await this.loadMissingSideMembers(allocationScaniaUnitId, from, to, state.missingSideMembersPaging, state.missingSideMembersSortExpression, state.missingSideMembersFilterExpression);
    }

    async update(allocationScaniaUnitId: number[], from: string, to: string): Promise<any> { 
        const payload = {
            from: new Date(from).toISOString(),
            to: new Date(to).toISOString(),
            allocationScaniaUnit: allocationScaniaUnitId
        }
        const response = await this.missingSideMembersApiService.updateMissingSideMembers(payload);
        if (response.errors) {
            const errors = response.errors.map((err: { message: any; }) => err.message);
            return errors;
        }        
        this.appStore.dispatch(new ChangeMissingSideMembersFilterExpressionAction(""));
        return response;
        
    }

    getList(): Observable<MissingSideMembers[]> {
        return this.appStore.select(state => state.missingSideMembers.missingSideMembers);
    }

    getSortingExpression(): Observable<string> {
        return this.appStore.select(state => state.missingSideMembers.missingSideMembersSortExpression);
    }

    sort(sortExpression: string) {
        this.appStore.dispatch(new ChangeMissingSideMembersSortExpressionAction(sortExpression));
    }

    getFilterExpression(): Observable<string> {
        return this.appStore.select(state => state.missingSideMembers.missingSideMembersFilterExpression);
    }

    filter(filterExpression: string) {
        this.appStore.dispatch(new ChangeMissingSideMembersFilterExpressionAction(filterExpression));
    }

    getPaging(): Observable<Paging> {
        return this.appStore.select(state => state.missingSideMembers.missingSideMembersPaging);
    }

    goToPage(page: number) {
        this.appStore.dispatch(new ChangeMissingSideMembersPageAction(page));
    }

    getTotalCount(): Observable<number> {
        return this.appStore.select(state => state.missingSideMembers.missingSideMembersTotalCount);
    }

    clearFilterAndSorting() {
        [
            new ChangeMissingSideMembersSortExpressionAction(null),
            new ChangeMissingSideMembersFilterExpressionAction(null)
        ].forEach(action => this.appStore.dispatch(action));
    }
}
